import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

export default function Settings() {
  const { userProfile } = useAuth();
  const isAdmin = userProfile?.role === 'admin';
  const [saved, setSaved] = useState(false);

  function handleSave(e) {
    e.preventDefault();
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  }

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">Settings</div>
          <div className="topbar-sub">{isAdmin ? 'Configure Zeptomail and subdomain' : 'Your account preferences'}</div>
        </div>
      </div>
      <div className="content">

        {/* Admin-only sections */}
        {isAdmin ? (
          <>
            <div className="card">
              <div className="card-title">⚙ Zeptomail configuration</div>
              <div className="alert alert-info" style={{ marginBottom: 16, fontSize: 12 }}>
                Your API key is stored as a Netlify environment variable — never exposed in the browser.
                Set it at <strong>Netlify → Site settings → Environment variables</strong> as <code>ZEPTOMAIL_API_KEY</code>.
              </div>
              <form onSubmit={handleSave}>
                <div className="field">
                  <label className="field-label">Sending region</label>
                  <select>
                    <option value="https://api.zeptomail.com/v1.1">Global (api.zeptomail.com)</option>
                    <option value="https://api.zeptomail.in/v1.1">India (api.zeptomail.in)</option>
                    <option value="https://api.zeptomail.eu/v1.1">EU (api.zeptomail.eu)</option>
                  </select>
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 4 }}>Also set <code>ZEPTOMAIL_REGION</code> as a Netlify env variable</div>
                </div>
                <div className="actions">
                  <button type="submit" className="btn btn-primary">{saved ? '✓ Saved' : 'Save settings'}</button>
                </div>
              </form>
            </div>

            <div className="card">
              <div className="card-title">🌐 Subdomain setup</div>
              <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.8 }}>
                <p>To point <strong>chitthi.cmfellowship.in</strong> to this Netlify app:</p>
                <ol style={{ marginLeft: 20, marginTop: 10 }}>
                  <li>In Netlify → Domain settings → Add custom domain: <code>chitthi.cmfellowship.in</code></li>
                  <li>In your DNS provider, add a <strong>CNAME</strong> record:</li>
                </ol>
                <div style={{ background: 'var(--bg2)', borderRadius: 'var(--radius)', padding: '10px 14px', marginTop: 10, fontFamily: 'monospace', fontSize: 12 }}>
                  Name: chitthi<br />
                  Type: CNAME<br />
                  Value: [your-netlify-app].netlify.app
                </div>
                <p style={{ marginTop: 10 }}>Netlify will auto-provision SSL via Let's Encrypt.</p>
              </div>
            </div>
          </>
        ) : (
          <div className="card">
            <div className="alert alert-info">
              App configuration (Zeptomail, subdomain) is managed by your administrator.
            </div>
            <div style={{ textAlign: 'center', padding: '30px 0', color: 'var(--text3)', fontSize: 13 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🔒</div>
              Contact your admin to update app settings.
            </div>
          </div>
        )}
      </div>
    </>
  );
}
